/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneSchemaMarkup as ResolvedStandaloneSchemaMarkup } from 'base/components/standalone/SchemaMarkup';

export const SchemaMarkup: typeof ResolvedStandaloneSchemaMarkup = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneSchemaMarkup {...props} />
    );
});

export type SchemaMarkupProps = PropsFromComponent<typeof SchemaMarkup>;

/** @deprecated Use slot architecture instead */
export const SchemaMarkupWith = (extras: DynamicStandaloneExtras): typeof SchemaMarkup => {
    return function SchemaMarkup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SchemaMarkup');
        return <ResolvedStandaloneSchemaMarkup {...mergeProps({ options: { theme } }, props)} />;
    }
}